import { createContext, useContext, useMemo, useState } from 'react';
import {
  getStoredSession,
  loginWithPassword,
  logout as logoutService
} from '../services/authService';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const initial = getStoredSession();
  const [token, setToken] = useState(initial?.token || localStorage.getItem('token') || '');
  const [user, setUser] = useState(initial?.user || null);

  const login = async (form) => {
    const session = await loginWithPassword(form);
    setToken(session.token);
    setUser(session.user);
    localStorage.setItem('token', session.token);
    return session.user;
  };

  const logout = () => {
    logoutService();
    setToken('');
    setUser(null);
    localStorage.removeItem('token');
  };

  const value = useMemo(
    () => ({
      token,
      user,
      isAuthenticated: Boolean(token && user),
      login,
      logout,
      setUser
    }),
    [token, user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used inside AuthProvider');
  }
  return ctx;
}
